import { useBreadcrumbBuilder } from "./useBreadcrumbBuilder";

export default useBreadcrumbBuilder;
